import { useEffect } from "react";

/**
 * Hook that detects clicks outside of the referenced element
 * and calls the provided callback.
 * @param {React.RefObject} ref - Ref to the element to monitor
 * @param {Function} onClickOutside - Callback to invoke on outside click
 */
export default function useClickOutside(ref, onClickOutside) {
  useEffect(() => {
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClickOutside();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [ref, onClickOutside]);
}
